import {
  AddApplicationType,
  PublicOfferMarkerType,
  OfferRateType,
  ApplicationType,
  AddSurveyAnswerType,
  AnalyticsEventType,
} from "@jobintrans/base-ui.types.api"
import { APIService } from "./APIService"

const getMarker = (id: string) =>
  APIService.get<null, PublicOfferMarkerType>(`/offers/${id}/marker`)

const apply = (id: string, body: AddApplicationType) =>
  APIService.post<null, ApplicationType>(`/offers/${id}/apply`, body)
const track = (id?: string, type?: AnalyticsEventType) =>
  APIService.post<null, null>(`/offers/${id}/track?type=${type}`)
const getVerifyCode = (id: string, applyId: string) =>
  APIService.get<null, null>(`/offers/${id}/apply/${applyId}/verify`)
const verify = (id: string, applyId: string, code: string) =>
  APIService.post<null, null>(`/offers/${id}/apply/${applyId}/verify?code=${code}`)
const confirm = (id: string, applyId: string) =>
  APIService.post<null, null>(`/offers/${id}/apply/${applyId}/confirm`)
const survey = (id: string, surveyId: string, applicationId: string, body: AddSurveyAnswerType) =>
  APIService.post<null, null>(
    `/offers/${id}/survey/${surveyId}?applicationId=${applicationId}`,
    body,
  )
const rate = (id: string, body: OfferRateType) =>
  APIService.post<null, null>(`/offers/${id}/rate`, body)
export const OfferService = {
  getMarker,
  apply,
  track,
  getVerifyCode,
  verify,
  confirm,
  rate,
  survey,
}
